module.exports = __webpack_public_path__ + "static/media/carta_64.9dfc7cc2.jpg";